import {
  PublicClientApplication,
  Configuration,
  LogLevel,
} from "@azure/msal-browser";

const baseLogger = {
  loggerOptions: {
    loggerCallback: (_level: LogLevel, message: string) => {
      if (import.meta.env.DEV) console.debug("[MSAL]", message);
    },
    piiLoggingEnabled: false,
  },
};

export const customerMsalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_CUSTOMER_CLIENT_ID,
    authority: import.meta.env.VITE_CUSTOMER_AUTHORITY,
    redirectUri: import.meta.env.VITE_CUSTOMER_REDIRECT_URI,
    knownAuthorities: [
      new URL(import.meta.env.VITE_CUSTOMER_AUTHORITY || "https://login.microsoftonline.com").hostname,
    ],
  },
  cache: { cacheLocation: "sessionStorage", storeAuthStateInCookie: false },
  system: baseLogger,
};

export const staffMsalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_STAFF_CLIENT_ID,
    authority: import.meta.env.VITE_STAFF_AUTHORITY,
    redirectUri: import.meta.env.VITE_STAFF_REDIRECT_URI,
  },
  cache: { cacheLocation: "sessionStorage", storeAuthStateInCookie: false },
  system: baseLogger,
};

export const customerMsalInstance = new PublicClientApplication(customerMsalConfig);
export const staffMsalInstance = new PublicClientApplication(staffMsalConfig);

export const customerLoginScopes = ["openid", "profile", "email"];
export const staffLoginScopes = ["openid", "profile", "email", "User.Read"];
